import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'

const isProduction = process.env.NODE_ENV === 'production';

const router = createRouter({
  history: isProduction ? createWebHistory('/wx_mis/') : createWebHashHistory(''), // 部署模式使用 createWebHistory，开发模式使用 createWebHashHistory
  //history: createWebHistory('/wx_mis/'), // hash模式：createWebHashHistory，history模式：createWebHistory     部署模式
  //history: createWebHashHistory(''), // hash模式：createWebHashHistory，history模式：createWebHistory     开发模式
  routes: [
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ '@/views/Home.vue'),
      meta: {
        index: 1,
        title: '首页'

      }
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue'),
      meta: {
        index: 2,
        title: '登录系统'
      }
    },
    {
      path: '/logout',
      name: 'logout',
      component: () => import(/* webpackChunkName: "logout" */ '@/views/Logout.vue'),
      meta: {
        index: 3,
        title: '退出账号'
      }
    },
    {
      path: '/cf_login/:tokenStr',
      name: 'cf_login',
      component: () => import(/* webpackChunkName: "cf_login" */ '@/views/System/Cf_Login.vue'),
      meta: {
        index: 4,
        title: '确认登录'
      }
    },
    {
      path: '/success',
      name: 'success',
      component: () => import(/* webpackChunkName: "success" */ '@/views/System/Success.vue'),
      meta: {
        index: 5,
        title: '操作成功'
      }
    },
    {
      path: '/fail',
      name: 'fail',
      component: () => import(/* webpackChunkName: "fail" */ '@/views/System/Fail.vue'),
      meta: {
        index: 6,
        title: '操作失败'
      }
    },
    {
      path: '/jobcenter',
      name: 'jobcenter',
      component: () => import(/* webpackChunkName: "jobcenter" */ '@/views/Job/Jobcenter.vue'),
      meta: {
        index: 7,
        title: '待办事项'
      }
    },
    {
      path: '/clock',
      name: 'clock',
      component: () => import(/* webpackChunkName: "clock" */ '@/views/Hr/Clock.vue'),
      meta: {
        index: 8,
        title: '考勤打卡'
      }
    },
    {
      path: '/leaveApply',
      name: 'leaveApply',
      component: () => import(/* webpackChunkName: "leaveApply" */ '@/views/Hr/Leave_Apply.vue'),
      meta: {
        index: 9,
        title: '请假申请'
      }
    },
    {
      path: '/foods',
      name: 'foods',
      component: () => import(/* webpackChunkName: "foods" */ '@/views/Foods/Foods.vue'),
      meta: {
        index: 10,
        title: '美食每客'
      }
    },
    {
      path: '/foods_log',
      name: 'foods_log',
      component: () => import(/* webpackChunkName: "foods_log" */ '@/views/Foods/Foods_Log.vue'),
      meta: {
        index: 11,
        title: '订餐记录'
      }
    },
    {
      path: '/account_charge',
      name: 'account_charge',
      component: () => import(/* webpackChunkName: "account_charge" */ '@/views/Foods/Account_Charge.vue'),
      meta: {
        index: 12,
        title: '充值记录'
      }
    },
    {
      path: '/foods_cancel/:trace_id',
      name: 'foods_cancel',
      component: () => import(/* webpackChunkName: "foods_cancel" */ '@/views/Foods/Foods_Cancel.vue'),
      meta: {
        index: 13,
        title: '退餐申请'
      }
    },
    {
      path: '/returnPay',
      name: 'returnPay',
      component: () => import(/* webpackChunkName: "returnPay" */ '@/views/Foods/ReturnPay.vue'),
      meta: {
        index: 14,
        title: '退餐记录'
      }
    },
    {
      path: '/edu',
      name: 'edu',
      component: () => import(/* webpackChunkName: "edu" */ '@/views/Edu.vue'),
      meta: {
        index: 15,
        title: '培训教育'
      }
    },
    {
      path: '/gift',
      name: 'gift',
      component: () => import(/* webpackChunkName: "gift" */ '@/views/Gift/Gift.vue'),
      meta: {
        index: 16,
        title: '物资中心'
      }
    },
    {
      path: '/gift_scan',
      name: 'gift_scan',
      component: () => import(/* webpackChunkName: "gift_scan" */ '@/views/Gift/Gift_Scan.vue'),
      meta: {
        index: 17,
        title: '验证物品'
      }
    },
    {
      path: '/gift_list/:tokenStr',
      name: 'gift_list',
      component: () => import(/* webpackChunkName: "gift_list" */ '@/views/Gift/Gift_List.vue'),
      meta: {
        index: 18,
        title: '物品申请'
      }
    },
    {
      path: '/gift_log',
      name: 'gift_log',
      component: () => import(/* webpackChunkName: "gift_log" */ '@/views/Gift/Gift_Log.vue'),
      meta: {
        index: 19,
        title: '我的物品申请'
      }
    },
    {
      path: '/gift_view/:trace_id',
      name: 'gift_view',
      component: () => import(/* webpackChunkName: "gift_view" */ '@/views/Gift/Gift_View.vue'),
      meta: {
        index: 20,
        title: '查看物品申请单'
      }
    },
    {
      path: '/gift_confirm/:trace_id',
      name: 'gift_confirm',
      component: () => import(/* webpackChunkName: "gift_confirm" */ '@/views/Gift/Gift_Confirm.vue'),
      meta: {
        index: 30,
        title: '出库确认'
      }
    },
    {
      path: '/seal',
      name: 'seal',
      component: () => import(/* webpackChunkName: "seal" */ '@/views/Seal/Seal.vue'),
      meta: {
        index: 31,
        title: '用章申请'
      }
    },
    {
      path: '/seal_apply/:value/:name',
      name: 'seal_apply',
      component: () => import(/* webpackChunkName: "seal_apply" */ '@/views/Seal/Seal_Apply.vue'),
      meta: {
        index: 32,
        title: '填写申请'
      }
    },
    {
      path: '/seal_log',
      name: 'seal_log',
      component: () => import(/* webpackChunkName: "seal_log" */ '@/views/Seal/Seal_Log.vue'),
      meta: {
        index: 33,
        title: '用章记录'
      }
    },
    {
      path: '/seal_view/:trace_id',
      name: 'seal_view',
      component: () => import(/* webpackChunkName: "seal_view" */ '@/views/Seal/Seal_View.vue'),
      meta: {
        index: 34,
        title: '查看记录'
      }
    },
    {
      path: '/car',
      name: 'car',
      component: () => import(/* webpackChunkName: "car" */ '@/views/Car/Car.vue'),
      meta: {
        index: 35,
        title: '用车申请'
      }
    },
    {
      path: '/car_apply/:cardata',
      name: 'car_apply',
      component: () => import(/* webpackChunkName: "car_apply" */ '@/views/Car/Car_Apply.vue'),
      meta: {
        index: 36,
        title: '填写申请'
      }
    },
    {
      path: '/car_view/:trace_id',
      name: 'car_view',
      component: () => import(/* webpackChunkName: "car_view" */ '@/views/Car/Car_View.vue'),
      meta: {
        index: 37,
        title: '查看用车'
      }
    },
    {
      path: '/car_log',
      name: 'car_log',
      component: () => import(/* webpackChunkName: "car_log" */ '@/views/Car/Car_Log.vue'),
      meta: {
        index: 38,
        title: '用车记录'
      }
    },
    {
      path: '/car_return/:trace_id',
      name: 'car_return',
      component: () => import(/* webpackChunkName: "car_return" */ '@/views/Car/Car_Return.vue'),
      meta: {
        index: 39,
        title: '车辆归还'
      }
    },
    {
      path: '/siteroom_car_return/:trace_id',
      name: 'siteroom_car_return',
      component: () => import(/* webpackChunkName: "siteroom_car_return" */ '@/views/Car/Siteroom_Car_Return.vue'),
      meta: {
        index: 40,
        title: '现场室还车'
      }
    },
    {
      path: '/car_return_professor/:trace_id',
      name: 'car_return_professor',
      component: () => import(/* webpackChunkName: "car_return_professor" */ '@/views/Car/Car_Return_Professor.vue'),
      meta: {
        index: 41,
        title: '专家还车'
      }
    },
    {
      path: '/client',
      name: 'client',
      component: () => import(/* webpackChunkName: "client" */ '@/views/Biz/Client.vue'),
      meta: {
        index: 42,
        title: '客户信息'
      }
    },
    {
      path: '/client_add',
      name: 'client_add',
      component: () => import(/* webpackChunkName: "client_add" */ '@/views/Biz/Client_Add.vue'),
      meta: {
        index: 43,
        title: '新增客户'
      }
    },
    {
      path: '/partners_add',
      name: 'partners_add',
      component: () => import(/* webpackChunkName: "partners_add" */ '@/views/Biz/Partners_Add.vue'),
      meta: {
        index: 44,
        title: '新增专家'
      }
    },
    {
      path: '/client_linkman',
      name: 'client_linkman',
      component: () => import(/* webpackChunkName: "client_linkman" */ '@/views/Biz/Client_Linkman.vue'),
      meta: {
        index: 45,
        title: '企业联系人'
      }
    },
    {
      path: '/client_linkman_add',
      name: 'client_linkman_add',
      component: () => import(/* webpackChunkName: "client_linkman_add" */ '@/views/Biz/Client_Linkman_Add.vue'),
      meta: {
        index: 46,
        title: '新增企业联系人'
      }
    },
    {
      path: '/client_invoice',
      name: 'client_invoice',
      component: () => import(/* webpackChunkName: "client_invoice" */ '@/views/Biz/Client_Invoice.vue'),
      meta: {
        index: 47,
        title: '企业开票信息'
      }
    },
    {
      path: '/client_invoice_add',
      name: 'client_invoice_add',
      component: () => import(/* webpackChunkName: "client_invoice_add" */ '@/views/Biz/Client_Invoice_Add.vue'),
      meta: {
        index: 48,
        title: '新增开票信息'
      }
    },
    {
      path: '/client_invoice_view/:id',
      name: 'client_invoice_view',
      component: () => import(/* webpackChunkName: "client_invoice_view" */ '@/views/Biz/Client_Invoice_View.vue'),
      meta: {
        index: 49,
        title: '查看开票信息'
      }
    },
    {
      path: '/client_view/:id',
      name: 'client_view',
      component: () => import(/* webpackChunkName: "client_view" */ '@/views/Biz/Client_View.vue'),
      meta: {
        index: 50,
        title: '客户信息'
      }
    },
    {
      path: '/bizPlan',
      name: 'bizPlan',
      component: () => import(/* webpackChunkName: "bizPlan" */ '@/views/Biz/Biz_Plan.vue'),
      meta: {
        index: 51,
        title: '业务目标'
      }
    },
    {
      path: '/projofferAdd',
      name: 'projofferAdd',
      component: () => import(/* webpackChunkName: "projofferAdd" */ '@/views/Biz/Proj_OfferPrice_Add.vue'),
      meta: {
        index: 60,
        title: '报价申请'
      }
    },
    {
      path: '/apply_Proj',
      name: 'apply_Proj',
      component: () => import(/* webpackChunkName: "apply_Proj" */ '@/views/Biz/Apply_Proj.vue'),
      meta: {
        index: 61,
        title: '待立项提交列表'
      }
    },
    {  //这是“待立项提交列表”里面的立项提交页面
      path: '/apply_proj_submit/:trace_id',
      name: 'apply_proj_submit',
      component: () => import(/* webpackChunkName: "apply_proj_submit" */ '@/views/Biz/Apply_Proj_Submit.vue'),
      meta: {
        index: 62,
        title: '立项提交'
      }
    },
    {
      path: '/bizAchieve',
      name: 'bizAchieve',
      component: () => import(/* webpackChunkName: "bizAchieve" */ '@/views/Biz/Biz_Achieve.vue'),
      meta: {
        index: 63,
        title: '业务绩效'
      }
    },
    {
      path: '/achieve_cash',
      name: 'achieve_cash',
      component: () => import(/* webpackChunkName: "achieve_cash" */ '@/views/User/Achieve_Cash.vue'),
      meta: {
        index: 64,
        title: '绩效提取记录'
      }
    },
    {
      path: '/myProj',
      name: 'myProj',
      component: () => import(/* webpackChunkName: "myProj" */ '@/views/Biz/My_Proj.vue'),
      meta: {
        index: 65,
        title: '我的项目'
      }
    },
    {
      path: '/projtorun',
      name: 'projtorun',
      component: () => import(/* webpackChunkName: "projtorun" */ '@/views/Biz/Proj_To_Run.vue'),
      meta: {
        index: 66,
        title: '业务分配'
      }
    },
    {
      path: '/taskToRun/:trace_id',
      name: 'taskToRun',
      component: () => import(/* webpackChunkName: "taskToRun" */ '@/views/Biz/Task_To_Run.vue'),
      meta: {
        index: 67,
        title: '分配业务经理'
      }
    },
    {
      path: '/taskToTech/:trace_id',
      name: 'taskToTech',
      component: () => import(/* webpackChunkName: "taskToTech" */ '@/views/Biz/Task_To_Tech.vue'),
      meta: {
        index: 68,
        title: '转交技术'
      }
    },
    {
      path: '/projtotech',
      name: 'projtotech',
      component: () => import(/* webpackChunkName: "projtotech" */ '@/views/Biz/Proj_To_Tech.vue'),
      meta: {
        index: 69,
        title: '转交技术'
      }
    },
    //立项人项目查看
    {
      path: '/proj_add_view/:trace_id',
      name: 'proj_add_view',
      component: () => import(/* webpackChunkName: "proj_add_view" */ '@/views/Biz/Proj_Add_View.vue'),
      meta: {
        index: 70,
        title: '查看项目'
      }
    },
    //执行人项目查看
    {
      path: '/proj_run_view/:trace_id',
      name: 'proj_run_view',
      component: () => import(/* webpackChunkName: "proj_run_view" */ '@/views/Biz/Proj_Run_View.vue'),
      meta: {
        index: 71,
        title: '查看项目'
      }
    },
    //项目费用
    {
      path: '/proj_back/:trace_id',
      name: 'proj_back',
      component: () => import(/* webpackChunkName: "proj_back" */ '@/views/Biz/Proj_Back.vue'),
      meta: {
        index: 72,
        title: '项目费用'
      }
    },
    //执行费用
    {
      path: '/proj_cost/:trace_id/:cost_id',
      name: 'proj_cost',
      component: () => import(/* webpackChunkName: "proj_cost" */ '@/views/Biz/Proj_Cost.vue'),
      meta: {
        index: 73,
        title: '执行费用'
      }
    },
    //任务查看
    {
      path: '/task_view/:trace_id',
      name: 'task_view',
      component: () => import(/* webpackChunkName: "task_view" */ '@/views/Tech/Task_View.vue'),
      meta: {
        index: 74,
        title: '查看任务'
      }
    },
    //任务查看
    {
      path: '/task_comp_view/:trace_id',
      name: 'task_comp_view',
      component: () => import(/* webpackChunkName: "task_comp_view" */ '@/views/Biz/Task_Comp_View.vue'),
      meta: {
        index: 75,
        title: '查看任务'
      }
    },
    //我的任务
    {
      path: '/myTask',
      name: 'myTask',
      component: () => import(/* webpackChunkName: "myTask" */ '@/views/Biz/My_Task.vue'),
      meta: {
        index: 76,
        title: '我的任务'
      }
    },
    {
      path: '/recMoney',
      name: 'recMoney',
      component: () => import(/* webpackChunkName: "recMoney" */ '@/views/Biz/Rec_Money.vue'),
      meta: {
        index: 77,
        title: '回款统计'
      }
    },
    {
      path: '/invoice',
      name: 'invoice',
      component: () => import(/* webpackChunkName: "invoice" */ '@/views/Biz/Invoice.vue'),
      meta: {
        index: 78,
        title: '发票统计'
      }
    },
    //发票查看
    {
      path: '/invoice_view/:trace_id',
      name: 'invoice_view',
      component: () => import(/* webpackChunkName: "invoice_view" */ '@/views/Biz/Invoice_View.vue'),
      meta: {
        index: 79,
        title: '查看发票'
      }
    },
    //发票查看
    {
      path: '/recmoney_view/:trace_id',
      name: 'recmoney_view',
      component: () => import(/* webpackChunkName: "recmoney_view" */ '@/views/Biz/Recmoney_View.vue'),
      meta: {
        index: 80,
        title: '查看回款'
      }
    },
    {
      path: '/techList',
      name: 'techList',
      component: () => import(/* webpackChunkName: "techList" */ '@/views/Tech/Tech_List.vue'),
      meta: {
        index: 90,
        title: '任务统计'
      }
    },
    {
      path: '/TechAchieve',
      name: 'TechAchieve',
      component: () => import(/* webpackChunkName: "TechAchieve" */ '@/views/Tech/Tech_Achieve.vue'),
      meta: {
        index: 91,
        title: '技术绩效'
      }
    },
    {
      path: '/siteroom_car_log',
      name: 'siteroom_car_log',
      component: () => import(/* webpackChunkName: "Siteroom_Car_Log" */ '@/views/Car/Siteroom_Car_Log.vue'),
      meta: {
        index: 92,
        title: '现场室还车'
      }
    },


    {
      path: '/expertUse',
      name: 'expertUse',
      component: () => import(/* webpackChunkName: "expertUse" */ '@/views/Tech/Expert_Use.vue'),
      meta: {
        index: 93,
        title: '专家申请'
      }
    },
    {
      path: '/TaskOrder',
      name: 'TaskOrder',
      component: () => import(/* webpackChunkName: "TaskOrder" */ '@/views/Tech/Task_Order.vue'),
      meta: {
        index: 94,
        title: '技术服务'
      }
    },
    {
      path: '/employee_achieve',
      name: 'employee_achieve',
      component: () => import(/* webpackChunkName: "employee_achieve" */ '@/views/Hr/Employee_Achieve.vue'),
      meta: {
        index: 95,
        title: '人工考核'
      }
    },
    {
      path: '/user',
      name: 'user',
      component: () => import(/* webpackChunkName: "user" */ '@/views/User.vue'),
      meta: {
        index: 96,
        title: '个人资料'
      }
    },
    {
      path: '/my_qrcode',
      name: 'my_qrcode',
      component: () => import(/* webpackChunkName: "my_qrcode" */ '@/views/User/My_QrCode.vue'),
      meta: {
        index: 97,
        title: '我的二维码'
      }
    },
    {
      path: '/account/:open_id',
      name: 'account',
      component: () => import(/* webpackChunkName: "account" */ '@/views/User/Account.vue'),
      meta: {
        index: 98,
        title: '账户充值'
      }
    },
    {
      path: '/charge',
      name: 'charge',
      component: () => import(/* webpackChunkName: "charge" */ '@/views/Foods/Charge_FoodsAccount.vue'),
      meta: {
        index: 99,
        title: '人工充值'
      }
    },
    {
      path: '/tocash/:cash/:org_id/:org_name',
      name: 'tocash',
      component: () => import(/* webpackChunkName: "tocash" */ '@/views/User/Tocash.vue'),
      meta: {
        index: 100,
        title: '绩效提现'
      }
    },
    {
      path: '/quotation',
      name: 'quotation',
      component: () => import(/* webpackChunkName: "quotation" */ '@/views/Proj/Quotation.vue'),
      meta: {
        index: 101,
        title: '报价查询'
      }
    },

    {
      path: '/public',
      name: 'public',
      component: () => import(/* webpackChunkName: "public" */ '@/views/Public.vue'),
      meta: {
        index: 102,
        title: '功能大厅'
      }
    },
    {
      path: '/contacts',
      name: 'contacts',
      component: () => import(/* webpackChunkName: "contacts" */ '@/views/Job/Contacts.vue'),
      meta: {
        index: 103,
        title: '通讯录'
      }
    },
    {
      path: '/employeeCar',
      name: 'employeeCar',
      component: () => import(/* webpackChunkName: "employeeCar" */ '@/views/Job/EmployeeCar.vue'),
      meta: {
        index: 104,
        title: '员工车辆'
      }
    },
    {
      path: '/notice/:trace_id',
      name: 'notice',
      component: () => import(/* webpackChunkName: "notice" */ '@/views/Job/Notice_Read.vue'),
      meta: {
        index: 105,
        title: '通知阅读'
      }
    },
    {
      path: '/borrowmoney',
      name: 'borrowmoney',
      component: () => import(/* webpackChunkName: "borrowmoney" */ '@/views/Fin/BorrowMoney.vue'),
      meta: {
        index: 106,
        title: '我的借款'
      }
    },
    {
      path: '/borrowmoney_view/:trace_id',
      name: 'borrowmoney_view',
      component: () => import(/* webpackChunkName: "borrowmoney_view" */ '@/views/Fin/BorrowMoney_View.vue'),
      meta: {
        index: 107,
        title: '查看借款单'
      }
    },
    {
      path: '/reimburse',
      name: 'reimburse',
      component: () => import(/* webpackChunkName: "reimburse" */ '@/views/Fin/Reimburse.vue'),
      meta: {
        index: 108,
        title: '我的报销'
      }
    },
    {
      path: '/reimburseview/:trace_id',
      name: 'reimburseview',
      component: () => import(/* webpackChunkName: "reimburseview" */ '@/views/Fin/Reimburse_View.vue'),
      meta: {
        index: 109,
        title: '查看报销单'
      }
    },
    {
      path: '/chatGpt',
      name: 'chatGpt',
      component: () => import(/* webpackChunkName: "chatGpt" */ '@/views/Job/ChatGpt.vue'),
      meta: {
        index: 110,
        title: 'AI查询'
      }
    },
    {
      path: '/salary',
      name: 'salary',
      component: () => import(/* webpackChunkName: "salary" */ '@/views/Fin/Salary.vue'),
      meta: {
        index: 111,
        title: '工资查询'
      }
    },
    {
      path: '/my_achieve',
      name: 'my_achieve',
      component: () => import(/* webpackChunkName: "my_achieve" */ '@/views/User/My_Achieve_List.vue'),
      meta: {
        index: 120,
        title: '绩效查询'
      }
    },
    {
      path: '/projCount',
      name: 'projCount',
      component: () => import(/* webpackChunkName: "projCount" */ '@/views/System/ProjCount.vue'),
      meta: {
        index: 121,
        title: '项目分析'
      }
    },
    {
      path: '/proj_count_view/:trace_id',
      name: 'proj_count_view',
      component: () => import(/* webpackChunkName: "proj_count_view" */ '@/views/System/ProjCount_View.vue'),
      meta: {
        index: 122,
        title: '分析项目'
      }
    },

    {
      path: '/clearToken',
      name: 'clearToken',
      component: () => import(/* webpackChunkName: "clearToken" */ '@/views/System/ClearToken.vue'),
      meta: {
        index: 123,
        title: 'Token清除'
      }
    },
    {
      path: '/accountChange',
      name: 'accountChange',
      component: () => import(/* webpackChunkName: "accountChange" */ '@/views/System/AccountChange.vue'),
      meta: {
        index: 124,
        title: '账户切换'
      }
    },
    {
      path: '/cleardata',
      name: 'cleardata',
      component: () => import(/* webpackChunkName: "cleardata" */ '@/views/System/ClearData.vue'),
      meta: {
        index: 125,
        title: '清除数据'
      }
    },
    {
      path: '/deladmincode',
      name: 'deladmincode',
      component: () => import(/* webpackChunkName: "deladmincode" */ '@/views/System/Del_Admincode.vue'),
      meta: {
        index: 126,
        title: '删除验证码'
      }
    },
    {
      path: '/delworklist',
      name: 'delworklist',
      component: () => import(/* webpackChunkName: "delworklist" */ '@/views/System/Del_Worklist.vue'),
      meta: {
        index: 127,
        title: '待办清理'
      }
    },
    {
      path: '/bizcount',
      name: 'bizcount',
      component: () => import(/* webpackChunkName: "bizcount" */ '@/views/System/Bizcount.vue'),
      meta: {
        index: 128,
        title: '业务数据'
      }
    },
    {
      path: '/giftconfig',
      name: 'giftconfig',
      component: () => import(/* webpackChunkName: "giftconfig" */ '@/views/Gift/Gift_Config.vue'),
      meta: {
        index: 129,
        title: '货品配置'
      }
    },
    {
      path: '/giftrange/:trace_id',
      name: 'giftrange',
      component: () => import(/* webpackChunkName: "giftrange" */ '@/views/Gift/Gift_Range.vue'),
      meta: {
        index: 130,
        title: '修改范围'
      }
    },
    {
      path: '/fixaccount',
      name: 'fixaccount',
      component: () => import(/* webpackChunkName: "fixaccount" */ '@/views/System/FixAccount.vue'),
      meta: {
        index: 131,
        title: '账户修复'
      }
    },
    {
      path: '/confirmpic',
      name: 'confirmpic',
      component: () => import(/* webpackChunkName: "confirmpic" */ '@/views/System/ConfirmPic.vue'),
      meta: {
        index: 132,
        title: '随手拍图片审核'
      }
    },
    {
      path: '/findpic_view/:trace_id',
      name: 'findpic_view',
      component: () => import(/* webpackChunkName: "findpic_view" */ '@/views/System/FindpicView.vue'),
      meta: {
        index: 133,
        title: '查看随手拍图片'
      }
    },

    /**
     * 这里开始是work_list的审批页面路由============================================================================
     * 待办事项
     */
    //查看各项费用支付单
    {
      path: '/workviews/out_money_view/:params/:state',
      name: 'out_money_view',
      component: () => import(/* webpackChunkName: "out_money_view" */ '@/views/work_views/Out_Money_View.vue'),
      meta: {
        index: 134,
        title: '查看付款单'
      }
    },
    {
      path: '/workviews/notice_sign/:trace_id/:state',
      name: 'notice_sign',
      component: () => import(/* webpackChunkName: "notice_sign" */ '@/views/work_views/Notice_Sign.vue'),
      meta: {
        index: 135,
        title: '通知审批'
      }
    },
    {
      path: '/workviews/notice_edit/:trace_id/:state',
      name: 'notice_edit',
      component: () => import(/* webpackChunkName: "notice_edit" */ '@/views/work_views/Notice_Edit.vue'),
      meta: {
        index: 136,
        title: '通知编辑'
      }
    },
    {
      path: '/workviews/notice_view/:trace_id/:state',
      name: 'notice_view',
      component: () => import(/* webpackChunkName: "notice_view" */ '@/views/work_views/Notice_View.vue'),
      meta: {
        index: 137,
        title: '通知查看'
      }
    },
    //用车
    {
      path: '/workviews/car_use_sign/:trace_id/:state',
      name: 'car_use_sign',
      component: () => import(/* webpackChunkName: "car_use_sign" */ '@/views/work_views/Car_Use_Sign.vue'),
      meta: {
        index: 138,
        title: '用车审批'
      }
    },
    {
      path: '/workviews/car_use_edit/:trace_id/:state',
      name: 'car_use_edit',
      component: () => import(/* webpackChunkName: "car_use_edit" */ '@/views/work_views/Car_Use_Edit.vue'),
      meta: {
        index: 139,
        title: '修改用车'
      }
    },
    {
      path: '/workviews/car_use_view/:trace_id/:state',
      name: 'car_use_view',
      component: () => import(/* webpackChunkName: "car_use_view" */ '@/views/work_views/Car_Use_View.vue'),
      meta: {
        index: 140,
        title: '查看用车'
      }
    },
    {
      path: '/workviews/car_use_back_edit/:trace_id/:state',
      name: 'car_use_back_edit',
      component: () => import(/* webpackChunkName: "car_use_back_edit" */ '@/views/work_views/Car_Use_Back_Edit.vue'),
      meta: {
        index: 150,
        title: '编辑还车'
      }
    },
    {
      path: '/workviews/car_use_confirm/:trace_id/:state',
      name: 'car_use_confirm',
      component: () => import(/* webpackChunkName: "car_use_confirm" */ '@/views/work_views/Car_Use_Confirm.vue'),
      meta: {
        index: 151,
        title: '确认还车'
      }
    },
    //交通补贴
    {
      path: '/workviews/gps_use_sign/:trace_id/:state',
      name: 'gps_use_sign',
      component: () => import(/* webpackChunkName: "gps_use_sign" */ '@/views/work_views/Gps_Use_Sign.vue'),
      meta: {
        index: 152,
        title: '交通补贴审批'
      }
    },
    {
      path: '/workviews/gps_use_edit/:trace_id/:state',
      name: 'gps_use_edit',
      component: () => import(/* webpackChunkName: "gps_use_edit" */ '@/views/work_views/Gps_Use_Edit.vue'),
      meta: {
        index: 153,
        title: '修改交通补贴'
      }
    },
    {
      path: '/workviews/gps_use_view/:trace_id/:state',
      name: 'gps_use_view',
      component: () => import(/* webpackChunkName: "gps_use_view" */ '@/views/work_views/Gps_Use_View.vue'),
      meta: {
        index: 154,
        title: '查看交通补贴申请'
      }
    },
    //交通补贴费用审批
    {
      path: '/workviews/gps_money_sign/:trace_id/:state',
      name: 'gps_money_sign',
      component: () => import(/* webpackChunkName: "gps_money_sign" */ '@/views/work_views/Gps_Money_Sign.vue'),
      meta: {
        index: 155,
        title: '交通补贴费用审批'
      }
    },
    {
      path: '/workviews/gps_money_edit/:trace_id/:state',
      name: 'gps_money_edit',
      component: () => import(/* webpackChunkName: "gps_money_edit" */ '@/views/work_views/Gps_Money_Edit.vue'),
      meta: {
        index: 156,
        title: '修改交通补贴费用'
      }
    },
    {
      path: '/workviews/gps_money_view/:trace_id/:state',
      name: 'gps_money_view',
      component: () => import(/* webpackChunkName: "gps_money_view" */ '@/views/work_views/Gps_Money_View.vue'),
      meta: {
        index: 157,
        title: '查看交通补贴申请'
      }
    },

    //用章审批
    {
      path: '/workviews/seal_chop_sign/:trace_id/:state',
      name: 'seal_chop_sign',
      component: () => import(/* webpackChunkName: "seal_chop_sign" */ '@/views/work_views/Seal_Chop_Sign.vue'),
      meta: {
        index: 158,
        title: '用章审批'
      }
    },
    //修改用章
    {
      path: '/workviews/seal_chop_edit/:trace_id/:state',
      name: 'seal_chop_edit',
      component: () => import(/* webpackChunkName: "seal_chop_edit" */ '@/views/work_views/Seal_Chop_Edit.vue'),
      meta: {
        index: 159,
        title: '用章审批'
      }
    },
    //查看用章
    {
      path: '/workviews/seal_chop_view/:trace_id/:state',
      name: 'seal_chop_view',
      component: () => import(/* webpackChunkName: "seal_chop_view" */ '@/views/work_views/Seal_Chop_View.vue'),
      meta: {
        index: 160,
        title: '查看用章'
      }
    },
    //物品审批
    {
      path: '/workviews/gift_order_sign/:trace_id/:state',
      name: 'gift_order_sign',
      component: () => import(/* webpackChunkName: "gift_order_sign" */ '@/views/work_views/Gift_Order_Sign.vue'),
      meta: {
        index: 161,
        title: '物品领用审批'
      }
    },
    //修改物品申请
    {
      path: '/workviews/gift_order_edit/:trace_id/:state',
      name: 'gift_order_edit',
      component: () => import(/* webpackChunkName: "gift_order_edit" */ '@/views/work_views/Gift_Order_Edit.vue'),
      meta: {
        index: 162,
        title: '修改领用申请'
      }
    },
    //查看物品申请
    {
      path: '/workviews/gift_order_view/:trace_id/:state',
      name: 'gift_order_view',
      component: () => import(/* webpackChunkName: "gift_order_view" */ '@/views/work_views/Gift_Order_View.vue'),
      meta: {
        index: 163,
        title: '查看领用申请'
      }
    },
    //借款审批
    {
      path: '/workviews/borrow_money_sign/:trace_id/:state',
      name: 'borrow_money_sign',
      component: () => import(/* webpackChunkName: "borrow_money_sign" */ '@/views/work_views/Borrow_Money_Sign.vue'),
      meta: {
        index: 164,
        title: '借款审批'
      }
    },
    //修改借款
    {
      path: '/workviews/borrow_money_edit/:trace_id/:state',
      name: 'borrow_money_edit',
      component: () => import(/* webpackChunkName: "borrow_money_edit" */ '@/views/work_views/Borrow_Money_Edit.vue'),
      meta: {
        index: 165,
        title: '修改借款'
      }
    },
    //查看借款
    {
      path: '/workviews/borrow_money_view/:trace_id/:state',
      name: 'borrow_money_view',
      component: () => import(/* webpackChunkName: "borrow_money_view" */ '@/views/work_views/Borrow_Money_View.vue'),
      meta: {
        index: 166,
        title: '查看借款'
      }
    },
    //借款核销审批
    {
      path: '/workviews/borrow_money_reimburse_sign/:trace_id/:state',
      name: 'borrow_money_reimburse_sign',
      component: () => import(/* webpackChunkName: "borrow_money_reimburse_sign" */ '@/views/work_views/Borrow_Money_Reimburse_Sign.vue'),
      meta: {
        index: 167,
        title: '修改借款'
      }
    },
    //修改借款核销
    {
      path: '/workviews/borrow_money_reimburse_edit/:trace_id/:state',
      name: 'borrow_money_reimburse_edit',
      component: () => import(/* webpackChunkName: "borrow_money_reimburse_edit" */ '@/views/work_views/Borrow_Money_Reimburse_Edit.vue'),
      meta: {
        index: 168,
        title: '修改核销'
      }
    },
    //查看借款核销
    {
      path: '/workviews/borrow_money_reimburse_view/:trace_id/:state',
      name: 'borrow_money_reimburse_view',
      component: () => import(/* webpackChunkName: "borrow_money_reimburse_view" */ '@/views/work_views/Borrow_Money_Reimburse_View.vue'),
      meta: {
        index: 169,
        title: '查看核销'
      }
    },
    //请假审批
    {
      path: '/workviews/leave_sign/:trace_id/:state',
      name: 'leave_sign',
      component: () => import(/* webpackChunkName: "leave_sign" */ '@/views/work_views/Leave_Sign.vue'),
      meta: {
        index: 170,
        title: '请假审批'
      }
    },
    //修改请假
    {
      path: '/workviews/leave_edit/:trace_id/:state',
      name: 'leave_edit',
      component: () => import(/* webpackChunkName: "leave_edit" */ '@/views/work_views/Leave_Edit.vue'),
      meta: {
        index: 180,
        title: '修改请假'
      }
    },
    //查看请假
    {
      path: '/workviews/leave_view/:trace_id/:state',
      name: 'leave_view',
      component: () => import(/* webpackChunkName: "leave_view" */ '@/views/work_views/Leave_View.vue'),
      meta: {
        index: 181,
        title: '查看请假'
      }
    },
    //报销审批
    {
      path: '/workviews/reimburse_sign/:trace_id/:state',
      name: 'reimburse_sign',
      component: () => import(/* webpackChunkName: "reimburse_sign" */ '@/views/work_views/Reimburse_Sign.vue'),
      meta: {
        index: 182,
        title: '报销审批'
      }
    },
    //报销编辑
    {
      path: '/workviews/reimburse_edit/:trace_id/:state',
      name: 'reimburse_edit',
      component: () => import(/* webpackChunkName: "reimburse_edit" */ '@/views/work_views/Reimburse_Edit.vue'),
      meta: {
        index: 183,
        title: '编辑报销'
      }
    },
    //查看报销
    {
      path: '/workviews/reimburse_view/:trace_id/:state',
      name: 'reimburse_view',
      component: () => import(/* webpackChunkName: "reimburse_view" */ '@/views/work_views/Reimburse_View.vue'),
      meta: {
        index: 184,
        title: '查看报销'
      }
    },
    //项目费用审批
    {
      path: '/workviews/proj_cost_sign/:trace_id/:state',
      name: 'proj_cost_sign',
      component: () => import(/* webpackChunkName: "proj_cost_sign" */ '@/views/work_views/Proj_Cost_Sign.vue'),
      meta: {
        index: 185,
        title: '项目费用审批'
      }
    },
    //项目费用编辑
    {
      path: '/workviews/proj_cost_edit/:trace_id/:state',
      name: 'proj_cost_edit',
      component: () => import(/* webpackChunkName: "proj_cost_edit" */ '@/views/work_views/Proj_Cost_Edit.vue'),
      meta: {
        index: 186,
        title: '项目费用修改'
      }
    },
    //查看项目费用
    {
      path: '/workviews/proj_cost_view/:trace_id/:state',
      name: 'proj_cost_view',
      component: () => import(/* webpackChunkName: "proj_cost_view" */ '@/views/work_views/Proj_Cost_View.vue'),
      meta: {
        index: 187,
        title: '查看项目费用'
      }
    },
    //咨询费(一)用审批
    {
      path: '/workviews/proj_sub_money_sign/:trace_id/:state',
      name: 'proj_sub_money_sign',
      component: () => import(/* webpackChunkName: "proj_sub_money_sign" */ '@/views/work_views/Proj_Sub_Money_Sign.vue'),
      meta: {
        index: 188,
        title: '咨询费(一)用审批'
      }
    },
    //咨询费(一)费用编辑
    {
      path: '/workviews/proj_sub_money_edit/:trace_id/:state',
      name: 'proj_sub_money_edit',
      component: () => import(/* webpackChunkName: "proj_sub_money_edit" */ '@/views/work_views/Proj_Sub_Money_Edit.vue'),
      meta: {
        index: 189,
        title: '咨询费(一)修改'
      }
    },
    //查看咨询费(一)费用
    {
      path: '/workviews/proj_sub_money_view/:trace_id/:state',
      name: 'proj_sub_money_view',
      component: () => import(/* webpackChunkName: "proj_sub_money_view" */ '@/views/work_views/Proj_Sub_Money_View.vue'),
      meta: {
        index: 190,
        title: '查看咨询费'
      }
    },
    //绩效提取审批
    {
      path: '/workviews/achievecash_sign/:trace_id/:state',
      name: 'achievecash_sign',
      component: () => import(/* webpackChunkName: "achievecash_sign" */ '@/views/work_views/AchieveCash_Sign.vue'),
      meta: {
        index: 191,
        title: '绩效提取审批'
      }
    },
    //绩效提取编辑
    {
      path: '/workviews/achievecash_edit/:trace_id/:state',
      name: 'achievecash_edit',
      component: () => import(/* webpackChunkName: "achievecash_edit" */ '@/views/work_views/AchieveCash_Edit.vue'),
      meta: {
        index: 192,
        title: '绩效提取审批'
      }
    },
    //查看绩效提取
    {
      path: '/workviews/achievecash_view/:trace_id/:state',
      name: 'achievecash_view',
      component: () => import(/* webpackChunkName: "achievecash_view" */ '@/views/work_views/AchieveCash_View.vue'),
      meta: {
        index: 193,
        title: '查看绩效提取'
      }
    },
    //项目相关=========================================================================================================
    //报价审批
    {
      path: '/workviews/proj_offerprice_sign/:trace_id/:state',
      name: 'proj_offerprice_sign',
      component: () => import(/* webpackChunkName: "proj_offerprice_sign" */ '@/views/work_views/Proj_OfferPrice_Sign.vue'),
      meta: {
        index: 194,
        title: '项目报价审批'
      }
    },
    //报价审批（华质）
    {
      path: '/workviews/proj_offerprice_sign_hz/:trace_id/:state',
      name: 'proj_offerprice_sign_hz',
      component: () => import(/* webpackChunkName: "proj_offerprice_sign_hz" */ '@/views/work_views/Proj_OfferPrice_Sign_HZ.vue'),
      meta: {
        index: 195,
        title: '项目报价审批'
      }
    },
    //报价编辑
    {
      path: '/workviews/proj_offerprice_edit/:trace_id/:state',
      name: 'proj_offerprice_edit',
      component: () => import(/* webpackChunkName: "proj_offerprice_edit" */ '@/views/work_views/Proj_OfferPrice_Edit.vue'),
      meta: {
        index: 196,
        title: '项目报价修改'
      }
    },
    //报价确认
    {
      path: '/workviews/proj_offerPrice_confirm/:trace_id/:state',
      name: 'proj_offerPrice_confirm',
      component: () => import(/* webpackChunkName: "proj_offerPrice_confirm" */ '@/views/work_views/Proj_OfferPrice_Confirm.vue'),
      meta: {
        index: 197,
        title: '报价确认'
      }
    },
    //报价确认（华质）
    {
      path: '/workviews/proj_offerPrice_confirm_hz/:trace_id/:state',
      name: 'proj_offerPrice_confirm_hz',
      component: () => import(/* webpackChunkName: "proj_offerPrice_confirm_hz" */ '@/views/work_views/Proj_OfferPrice_Confirm_HZ.vue'),
      meta: {
        index: 198,
        title: '报价确认'
      }
    },
    {
      path: '/workviews/proj_offerPrice_confirm_view/:trace_id/:state',
      name: 'proj_offerPrice_confirm_view',
      component: () => import(/* webpackChunkName: "proj_offerPrice_confirm_view" */ '@/views/work_views/Proj_OfferPrice_Confirm_View.vue'),
      meta: {
        index: 199,
        title: '报价查看'
      }
    },
    //查看报价
    {
      path: '/workviews/proj_offerprice_view/:trace_id/:state',
      name: 'proj_offerprice_view',
      component: () => import(/* webpackChunkName: "proj_offerprice_view" */ '@/views/work_views/Proj_OfferPrice_View.vue'),
      meta: {
        index: 200,
        title: '查看项目报价'
      }
    },
    //技术分析
    {
      path: '/workviews/proj_techanalys_sign/:trace_id/:state',
      name: 'proj_techanalys_sign',
      component: () => import(/* webpackChunkName: "proj_techanalys_sign" */ '@/views/work_views/Proj_TechAnalys_Sign.vue'),
      meta: {
        index: 210,
        title: '技术分析'
      }
    },
    //查看技术分析
    {
      path: '/workviews/proj_techAnalys_view/:trace_id/:state',
      name: 'proj_techAnalys_view',
      component: () => import(/* webpackChunkName: "proj_techAnalys_view" */ '@/views/work_views/Proj_TechAnalys_View.vue'),
      meta: {
        index: 211,
        title: '查看技术分析'
      }
    },
    //立项审批
    {
      path: '/workviews/proj_submit_sign/:trace_id/:state',
      name: 'proj_submit_sign',
      component: () => import(/* webpackChunkName: "proj_submit_sign" */ '@/views/work_views/Proj_Submit_Sign.vue'),
      meta: {
        index: 212,
        title: '立项审批'
      }
    },
    //立项编辑
    {
      path: '/workviews/Proj_Submit_edit/:trace_id/:state',
      name: 'Proj_Submit_edit',
      component: () => import(/* webpackChunkName: "Proj_Submit_edit" */ '@/views/work_views/Proj_Submit_Edit.vue'),
      meta: {
        index: 213,
        title: '编辑立项'
      }
    },
    //查看立项审批
    {
      path: '/workviews/proj_submit_view/:trace_id/:state',
      name: 'proj_submit_view',
      component: () => import(/* webpackChunkName: "proj_submit_view" */ '@/views/work_views/Proj_Submit_View.vue'),
      meta: {
        index: 214,
        title: '查看立项审批'
      }
    },
    //业务分配
    {
      path: '/workviews/proj_general/:trace_id/:state',
      name: 'proj_general',
      component: () => import(/* webpackChunkName: "proj_general" */ '@/views/work_views/Proj_General.vue'),
      meta: {
        index: 215,
        title: '业务分配'
      }
    },
    //任务执行
    {
      path: '/workviews/proj_task_add/:trace_id/:state',
      name: 'proj_task_add',
      component: () => import(/* webpackChunkName: "proj_task_add" */ '@/views/work_views/Proj_Task_Add.vue'),
      meta: {
        index: 216,
        title: '任务执行'
      }
    },
    //技术接收
    {
      path: '/workviews/proj_tech_add/:trace_id/:state',
      name: 'proj_tech_add',
      component: () => import(/* webpackChunkName: "proj_tech_add" */ '@/views/work_views/Proj_Tech_Add.vue'),
      meta: {
        index: 217,
        title: '技术接收'
      }
    },
    //业务转交技术
    {
      path: '/workviews/proj_task_to_tech/:trace_id/:state',
      name: 'proj_task_to_tech',
      component: () => import(/* webpackChunkName: "proj_task_to_tech" */ '@/views/work_views/Proj_Task_To_Tech.vue'),
      meta: {
        index: 218,
        title: '转交技术'
      }
    },
    //技术分配负责人接收转项目组长
    {
      path: '/workviews/proj_distribut_add/:trace_id/:state',
      name: 'proj_distribut_add',
      component: () => import(/* webpackChunkName: "proj_distribut_add" */ '@/views/work_views/Proj_Distribut_Add.vue'),
      meta: {
        index: 219,
        title: '转交技术'
      }
    },
    //项目组长任务接收
    {
      path: '/workviews/proj_receive_add/:trace_id/:state',
      name: 'proj_receive_add',
      component: () => import(/* webpackChunkName: "proj_receive_add" */ '@/views/work_views/Proj_Receive_Add.vue'),
      meta: {
        index: 220,
        title: '任务接收'
      }
    },
    //查看项目
    {
      path: '/workviews/proj_task_view/:trace_id/:state',
      name: 'proj_task_view',
      component: () => import(/* webpackChunkName: "proj_task_view" */ '@/views/work_views/Proj_Task_View.vue'),
      meta: {
        index: 221,
        title: '查看项目'
      }
    },
    {
      path: '/workviews/yewu_change_sign/:trace_id/:state',
      name: 'yewu_change_sign',
      component: () => import(/* webpackChunkName: "yewu_change_sign" */ '@/views/work_views/Yewu_Change_Sign.vue'),
      meta: {
        index: 222,
        title: '业务调整审批'
      }
    },
    {
      path: '/workviews/yewu_change_edit/:trace_id/:state',
      name: 'yewu_change_edit',
      component: () => import(/* webpackChunkName: "yewu_change_edit" */ '@/views/work_views/Yewu_Change_Edit.vue'),
      meta: {
        index: 223,
        title: '编辑业务调整'
      }
    },
    {
      path: '/workviews/yewu_change_view/:trace_id/:state',
      name: 'yewu_change_view',
      component: () => import(/* webpackChunkName: "yewu_change_view" */ '@/views/work_views/Yewu_Change_View.vue'),
      meta: {
        index: 224,
        title: '查看业务调整'
      }
    },
    {
      path: '/workviews/tech_change_sign/:trace_id/:state',
      name: 'tech_change_sign',
      component: () => import(/* webpackChunkName: "tech_change_sign" */ '@/views/work_views/Tech_Change_Sign.vue'),
      meta: {
        index: 225,
        title: '技术调整审批'
      }
    },
    {
      path: '/workviews/tech_change_edit/:trace_id/:state',
      name: 'tech_change_edit',
      component: () => import(/* webpackChunkName: "tech_change_edit" */ '@/views/work_views/Tech_Change_Edit.vue'),
      meta: {
        index: 226,
        title: '编辑技术调整'
      }
    },
    {
      path: '/workviews/tech_change_view/:trace_id/:state',
      name: 'tech_change_view',
      component: () => import(/* webpackChunkName: "tech_change_view" */ '@/views/work_views/Tech_Change_View.vue'),
      meta: {
        index: 227,
        title: '查看技术调整'
      }
    },
    {
      path: '/workviews/tech_change_sign_hz/:trace_id/:state',
      name: 'tech_change_sign_hz',
      component: () => import(/* webpackChunkName: "tech_change_sign_hz" */ '@/views/work_views/Tech_Change_Sign_HZ.vue'),
      meta: {
        index: 228,
        title: '技术调整审批'
      }
    },
    {
      path: '/workviews/tech_change_edit_hz/:trace_id/:state',
      name: 'tech_change_edit_hz',
      component: () => import(/* webpackChunkName: "tech_change_edit_hz" */ '@/views/work_views/Tech_Change_Edit_HZ.vue'),
      meta: {
        index: 229,
        title: '编辑技术调整'
      }
    },
    {
      path: '/workviews/tech_change_view_hz/:trace_id/:state',
      name: 'tech_change_view_hz',
      component: () => import(/* webpackChunkName: "tech_change_view_hz" */ '@/views/work_views/Tech_Change_View_HZ.vue'),
      meta: {
        index: 230,
        title: '查看技术调整'
      }
    },
    {
      path: '/workviews/proj_contract_sign/:trace_id/:state',
      name: 'proj_contract_sign',
      component: () => import(/* webpackChunkName: "proj_contract_sign" */ '@/views/work_views/Proj_Contract_Sign.vue'),
      meta: {
        index: 240,
        title: '合同上传审批'
      }
    },
    {
      path: '/workviews/proj_contract_edit/:trace_id/:state',
      name: 'proj_contract_edit',
      component: () => import(/* webpackChunkName: "proj_contract_edit" */ '@/views/work_views/Proj_Contract_Edit.vue'),
      meta: {
        index: 241,
        title: '合同维护编辑'
      }
    },
    {
      path: '/workviews/proj_contract_view/:trace_id/:state',
      name: 'proj_contract_view',
      component: () => import(/* webpackChunkName: "proj_contract_view" */ '@/views/work_views/Proj_Contract_View.vue'),
      meta: {
        index: 242,
        title: '合同审批查看'
      }
    },
    {
      path: '/workviews/proj_task_yewucomp_sign/:trace_id/:state',
      name: 'proj_task_yewucomp_sign',
      component: () => import(/* webpackChunkName: "proj_task_yewucomp_sign" */ '@/views/work_views/Proj_Task_Yewucomp_Sign.vue'),
      meta: {
        index: 243,
        title: '业务结算审批'
      }
    },
    {
      path: '/workviews/proj_task_yewucomp_edit/:trace_id/:state',
      name: 'proj_task_yewucomp_edit',
      component: () => import(/* webpackChunkName: "proj_task_yewucomp_edit" */ '@/views/work_views/Proj_Task_Yewucomp_Edit.vue'),
      meta: {
        index: 244,
        title: '业务结算编辑'
      }
    },
    {
      path: '/workviews/proj_task_yewucomp_view/:trace_id/:state',
      name: 'proj_task_yewucomp_view',
      component: () => import(/* webpackChunkName: "proj_task_yewucomp_view" */ '@/views/work_views/Proj_Task_Yewucomp_View.vue'),
      meta: {
        index: 245,
        title: '查看业务结算'
      }
    },
    {
      path: '/workviews/proj_task_techcomp_sign/:trace_id/:state',
      name: 'proj_task_techcomp_sign',
      component: () => import(/* webpackChunkName: "proj_task_techcomp_sign" */ '@/views/work_views/Proj_Task_TechComp_Sign.vue'),
      meta: {
        index: 246,
        title: '技术结算审批'
      }
    },
    {
      path: '/workviews/proj_task_techcomp_edit/:trace_id/:state',
      name: 'proj_task_techcomp_edit',
      component: () => import(/* webpackChunkName: "proj_task_techcomp_edit" */ '@/views/work_views/Proj_Task_TechComp_Edit.vue'),
      meta: {
        index: 247,
        title: '技术结算编辑'
      }
    },
    {
      path: '/workviews/proj_task_techcomp_view/:trace_id/:state',
      name: 'proj_task_techcomp_view',
      component: () => import(/* webpackChunkName: "proj_task_techcomp_view" */ '@/views/work_views/Proj_Task_TechComp_View.vue'),
      meta: {
        index: 248,
        title: '查看技术结算'
      }
    },
    {
      path: '/workviews/train_plan_yewucomp_sign/:trace_id/:state',
      name: 'train_plan_yewucomp_sign',
      component: () => import(/* webpackChunkName: "train_plan_yewucomp_sign" */ '@/views/work_views/Train_Plan_YewuComp_Sign.vue'),
      meta: {
        index: 249,
        title: '益甲子业务结算审批'
      }
    },
    {
      path: '/workviews/train_plan_yewucomp_edit/:trace_id/:state',
      name: 'train_plan_yewucomp_edit',
      component: () => import(/* webpackChunkName: "train_plan_yewucomp_edit" */ '@/views/work_views/Train_Plan_YewuComp_Edit.vue'),
      meta: {
        index: 250,
        title: '益甲子业务结算编辑'
      }
    },
    {
      path: '/workviews/train_plan_yewucomp_view/:trace_id/:state',
      name: 'train_plan_yewucomp_view',
      component: () => import(/* webpackChunkName: "train_plan_yewucomp_view" */ '@/views/work_views/Train_Plan_YewuComp_View.vue'),
      meta: {
        index: 251,
        title: '查看益甲子业务结算'
      }
    },
    //以下是经纬进度管理相关==========================================================================================
    {
      path: '/workviews/proj_task_jw_receive/:trace_id/:state',
      name: 'proj_task_jw_receive',
      component: () => import(/* webpackChunkName: "proj_task_jw_receive" */ '@/views/work_views/Proj_Task_JW_Receive.vue'),
      meta: {
        index: 252,
        title: '评审稿接收'
      }
    },
    {
      path: '/workviews/proj_task_jw_baogao_rec/:trace_id/:state',
      name: 'proj_task_jw_baogao_rec',
      component: () => import(/* webpackChunkName: "proj_task_jw_baogao_rec" */ '@/views/work_views/Proj_Task_JW_Baogao_Rec.vue'),
      meta: {
        index: 253,
        title: '终稿接收'
      }
    },
    {
      path: '/workviews/proj_task_jw_view/:trace_id/:state',
      name: 'proj_task_jw_view',
      component: () => import(/* webpackChunkName: "proj_task_jw_view" */ '@/views/work_views/Proj_Task_JW_View.vue'),
      meta: {
        index: 254,
        title: '查看归档项目'
      }
    },
    {
      path: '/workviews/proj_task_tech_unlock_sign/:trace_id/:state',
      name: 'proj_task_tech_unlock_sign',
      component: () => import(/* webpackChunkName: "proj_task_tech_unlock_sign" */ '@/views/work_views/Proj_Task_Tech_Unlock_Sign.vue'),
      meta: {
        index: 255,
        title: '项目恢复审批'
      }
    },
    {
      path: '/workviews/proj_task_tech_lock_sign/:trace_id/:state',
      name: 'proj_task_tech_lock_sign',
      component: () => import(/* webpackChunkName: "proj_task_tech_lock_sign" */ '@/views/work_views/Proj_Task_Tech_Lock_Sign.vue'),
      meta: {
        index: 256,
        title: '项目锁定审批'
      }
    },
    {
      path: '/workviews/proj_task_tech_unlock_edit/:trace_id/:state',
      name: 'proj_task_tech_unlock_edit',
      component: () => import(/* webpackChunkName: "proj_task_tech_unlock_edit" */ '@/views/work_views/Proj_Task_Tech_Unlock_Edit.vue'),
      meta: {
        index: 257,
        title: '编辑项目恢复'
      }
    },
    {
      path: '/workviews/proj_task_tech_lock_edit/:trace_id/:state',
      name: 'proj_task_tech_lock_edit',
      component: () => import(/* webpackChunkName: "proj_task_tech_lock_edit" */ '@/views/work_views/Proj_Task_Tech_Lock_Edit.vue'),
      meta: {
        index: 258,
        title: '编辑项目锁定'
      }
    },
    {
      path: '/workviews/proj_task_tech_unlock_view/:trace_id/:state',
      name: 'proj_task_tech_unlock_view',
      component: () => import(/* webpackChunkName: "proj_task_tech_unlock_view" */ '@/views/work_views/Proj_Task_Tech_Unlock_View.vue'),
      meta: {
        index: 259,
        title: '查看项目恢复'
      }
    },
    {
      path: '/workviews/proj_task_tech_lock_view/:trace_id/:state',
      name: 'proj_task_tech_lock_view',
      component: () => import(/* webpackChunkName: "proj_task_tech_lock_view" */ '@/views/work_views/Proj_Task_Tech_Lock_View.vue'),
      meta: {
        index: 260,
        title: '查看项目锁定'
      }
    },
    {
      path: '/workviews/proj_stop_sign/:trace_id/:state',
      name: 'proj_stop_sign',
      component: () => import(/* webpackChunkName: "proj_stop_sign" */ '@/views/work_views/Proj_Stop_Sign.vue'),
      meta: {
        index: 270,
        title: '项目停止审批'
      }
    },
    {
      path: '/workviews/proj_stop_view/:trace_id/:state',
      name: 'proj_stop_view',
      component: () => import(/* webpackChunkName: "proj_stop_view" */ '@/views/work_views/Proj_Stop_View.vue'),
      meta: {
        index: 271,
        title: '查看停止审批'
      }
    },
    {
      path: '/workviews/proj_stop_edit/:trace_id/:state',
      name: 'proj_stop_edit',
      component: () => import(/* webpackChunkName: "proj_stop_edit" */ '@/views/work_views/Proj_Stop_Edit.vue'),
      meta: {
        index: 272,
        title: '编辑项目停止'
      }
    },
    {
      path: '/workviews/proj_stop_money_client_sign/:trace_id/:state',
      name: 'proj_stop_money_client_sign',
      component: () => import(/* webpackChunkName: "proj_stop_money_client_sign" */ '@/views/work_views/Proj_Stop_Money_Client_Sign.vue'),
      meta: {
        index: 273,
        title: '项目停止审批'
      }
    },
    {
      path: '/workviews/proj_stop_money_client_view/:trace_id/:state',
      name: 'proj_stop_money_client_view',
      component: () => import(/* webpackChunkName: "proj_stop_money_client_view" */ '@/views/work_views/Proj_Stop_Money_Client_View.vue'),
      meta: {
        index: 274,
        title: '查看停止审批'
      }
    },
    {
      path: '/workviews/proj_stop_money_client_edit/:trace_id/:state',
      name: 'proj_stop_money_client_edit',
      component: () => import(/* webpackChunkName: "proj_stop_money_client_edit" */ '@/views/work_views/Proj_Stop_Money_Client_Edit.vue'),
      meta: {
        index: 275,
        title: '编辑项目停止'
      }
    },
    //经纬进度结束 ==================================================================================================
    {
      path: '/workviews/proj_invoice_print/:trace_id/:state',
      name: 'proj_invoice_print',
      component: () => import(/* webpackChunkName: "proj_invoice_print" */ '@/views/work_views/Proj_Invoice_Print.vue'),
      meta: {
        index: 276,
        title: '开票审批'
      }
    },
    {
      path: '/workviews/proj_invoice_sign/:trace_id/:state',
      name: 'proj_invoice_sign',
      component: () => import(/* webpackChunkName: "proj_invoice_sign" */ '@/views/work_views/Proj_Invoice_Sign.vue'),
      meta: {
        index: 277,
        title: '超额发票审批'
      }
    },
    {
      path: '/employee_car',
      name: 'employee_car',
      component: () => import(/* webpackChunkName: "employee_car" */ '@/views/Car/Employee_Car.vue'),
      meta: {
        index: 278,
        title: '交通费补贴申请'
      }
    },
    {
      path: '/employee_car_apply/:cardata',
      name: 'employee_car_apply',
      component: () => import(/* webpackChunkName: "employee_car_apply" */ '@/views/Car/Employee_Car_Apply.vue'),
      meta: {
        index: 279,
        title: '填写申请'
      }
    },
    {
      path: '/workviews/employee_car_return/:trace_id',
      name: 'employee_car_return',
      component: () => import(/* webpackChunkName: "employee_car_return" */ '@/views/work_views/Employee_Car_Return.vue'),
      meta: {
        index: 280,
        title: '用车返回'
      }
    },
    {
      path: '/workviews/gps_use_back_edit/:trace_id/:state',
      name: 'gps_use_back_edit',
      component: () => import(/* webpackChunkName: "gps_use_back_edit" */ '@/views/work_views/Gps_Use_Back_Edit.vue'),
      meta: {
        index: 281,
        title: '编辑交通补贴申请'
      }
    },
    {
      path: '/workviews/gps_use_confirm/:trace_id/:state',
      name: 'gps_use_confirm',
      component: () => import(/* webpackChunkName: "gps_use_confirm" */ '@/views/work_views/Gps_Use_Confirm.vue'),
      meta: {
        index: 282,
        title: '交通补助核定'
      }
    },
    {
      path: '/pai_proj_list',
      name: 'pai_proj_list',
      component: () => import(/* webpackChunkName: "pai_proj_list" */ '@/views/Tech/Pai_Proj_List.vue'),
      meta: {
        index: 283,
        title: '我的派单任务'
      }
    },
    {
      path: '/professor_car_apply/:cardata',
      name: 'professor_car_apply',
      component: () => import(/* webpackChunkName: "professor_car_apply" */ '@/views/Tech/Professor_Car_Apply.vue'),
      meta: {
        index: 284,
        title: '专家项目用车'
      }
    },
    {
      path: '/pai_task_view/:trace_id',
      name: 'pai_task_view',
      component: () => import(/* webpackChunkName: "pai_task_view" */ '@/views/Tech/Pai_Task_View.vue'),
      meta: {
        index: 285,
        title: '查看派单任务'
      }
    },
    {
      path: '/professor_car_apply/:cardata/:trace_id/:taskInfo',
      name: 'professor_car_apply',
      component: () => import(/* webpackChunkName: "professor_car_apply" */ '@/views/Car/Professor_Car_Apply.vue'),
      meta: {
        index: 286,
        title: '专家用车'
      }
    },
    {
      path: '/findpic',
      name: 'findpic',
      component: () => import(/* webpackChunkName: "findpic" */ '@/views/System/FindPic.vue'),
      meta: {
        index: 287,
        title: '发布图片'
      }
    },
    //华质技术分析
    {
      path: '/workviews/proj_techanalys_sign_hz/:trace_id/:state',
      name: 'proj_techanalys_sign_hz',
      component: () => import(/* webpackChunkName: "proj_techanalys_sign_hz" */ '@/views/work_views/Proj_TechAnalys_Sign_HZ.vue'),
      meta: {
        index: 288,
        title: '华质技术分析'
      }
    },
    //益甲子教育相关审批开始=========================================================================================================
    {
      path: '/workviews/trainterm_sign/:trace_id/:state',
      name: 'trainterm_sign',
      component: () => import(/* webpackChunkName: "trainterm_sign" */ '@/views/work_views/Trainterm_Sign.vue'),
      meta: {
        index: 289,
        title: '开班申请审核'
      }
    },
    {
      path: '/workviews/trainTerm_finish_sign/:trace_id/:state',
      name: 'trainTerm_finish_sign',
      component: () => import(/* webpackChunkName: "trainTerm_finish_sign" */ '@/views/work_views/TrainTerm_Finish_Sign.vue'),
      meta: {
        index: 290,
        title: '结班审核'
      }
    },
    {
      path: '/workviews/trainterm_costmoney_sign/:trace_id/:state',
      name: 'trainterm_costmoney_sign',
      component: () => import(/* webpackChunkName: "trainterm_costmoney_sign" */ '@/views/work_views/TrainTerm_CostMoney_Sign.vue'),
      meta: {
        index: 300,
        title: '费用审批'
      }
    },
        {
      path: '/workviews/trainterm_backmoney_sign/:trace_id/:state',
      name: 'trainterm_backmoney_sign',
      component: () => import(/* webpackChunkName: "trainterm_backmoney_sign" */ '@/views/work_views/Trainterm_Backmoney_Sign.vue'),
      meta: {
        index: 301,
        title: '学员咨询费一审批'
      }
    },
    {
      path: '/workviews/goods_plan_sign/:trace_id/:state',
      name: 'goods_plan_sign',
      component: () => import(/* webpackChunkName: "goods_plan_sign" */ '@/views/work_views/Goods_Plan_Sign.vue'),
      meta: {
        index: 302,
        title: '采购计划审批'
      }
    },
    {
      path: '/workviews/goods_order_sign/:trace_id/:state',
      name: 'goods_order_sign',
      component: () => import(/* webpackChunkName: "goods_order_sign" */ '@/views/work_views/Goods_Order_Sign.vue'),
      meta: {
        index: 303,
        title: '采购申请审批'
      }
    },
    {
      path: '/workviews/recruitment_apply_sign/:trace_id/:state',
      name: 'recruitment_apply_sign',
      component: () => import(/* webpackChunkName: "recruitment_apply_sign" */ '@/views/work_views/Recruitment_Apply_Sign.vue'),
      meta: {
        index: 304,
        title: '人员增补审批'
      }
    },
        {
      path: '/workviews/trainterm_master_sign/:trace_id/:state',
      name: 'trainterm_master_sign',
      component: () => import(/* webpackChunkName: "trainterm_master_sign" */ '@/views/work_views/TrainTerm_Master_Sign.vue'),
      meta: {
        index: 305,
        title: '班主任结算审核'
      }
    },
    {
      path: '/workviews/salarys_sign/:trace_id/:state',
      name: 'salarys_sign',
      component: () => import(/* webpackChunkName: "salarys_sign" */ '@/views/work_views/Salarys_Sign.vue'),
      meta: {
        index: 306,
        title: '工资列表审批'
      }
    }
    ,
    {
      path: '/workviews/proj_task_techcomp_hz_jc_allocate_sign/:trace_id/:state',
      name: 'proj_task_techcomp_hz_jc_allocate_sign',
      component: () => import(/* webpackChunkName: "proj_task_techcomp_hz_jc_allocate_sign" */ '@/views/work_views/Proj_Task_TechComp_HZ_JC_Allocate_Sign.vue'),
      meta: {
        index: 307,
        title: '华质检测类技术结算审批'
      }
    },
    {
      path: '/workviews/proj_task_hz_pai_receive/:trace_id/:state',
      name: 'proj_task_hz_pai_receive',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_receive" */ '@/views/work_views/Proj_Task_HZ_Pai_Receive.vue'),
      meta: {
        index: 308,
        title: '现场室派单接收'
      }
    },
    {
      path: '/workviews/proj_task_hz_pai_notice/:trace_id/:state',
      name: 'proj_task_hz_pai_notice',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_notice" */ '@/views/work_views/Proj_Task_HZ_Pai_Notice.vue'),
      meta: {
        index: 309,
        title: '现场室派单通知'
      }
    },
    {
      path: '/workviews/proj_task_hz_pai_done/:trace_id/:state',
      name: 'proj_task_hz_pai_done',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_done" */ '@/views/work_views/Proj_Task_HZ_Pai_Done.vue'),
      meta: {
        index: 310,
        title: '现场室派单完成'
      }
    }
    ,
    {
      path: '/workviews/proj_task_hz_pai_confirm/:trace_id/:state',
      name: 'proj_task_hz_pai_confirm',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_confirm" */ '@/views/work_views/Proj_Task_HZ_Pai_Confirm.vue'),
      meta: {
        index: 311,
        title: '现场室派单完成确认'
      }
    } , 
    {
      path: '/workviews/proj_task_hz_pai_piao_up/:trace_id/:state',
      name: 'proj_task_hz_pai_piao_up',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_piao_up" */ '@/views/work_views/Proj_Task_HZ_Pai_Piao_Up.vue'),
      meta: {
        index: 310,
        title: '现场派单票据上传'
      }
    },
    {
      path: '/workviews/proj_task_hz_pai_final/:trace_id/:state',
      name: 'proj_task_hz_pai_final',
      component: () => import(/* webpackChunkName: "proj_task_hz_pai_final" */ '@/views/work_views/Proj_Task_HZ_Pai_Final.vue'),
      meta: {
        index: 312,
        title: '现场室派单结束确认'
      }
    },
    {
      path: '/teamwork',
      name: 'teamwork',
      component: () => import(/* webpackChunkName: "teamwork" */ '@/views/Job/TeamWork.vue'),
      meta: {
        index: 313,
        title: '项目备案'
      }
    },
    //报价通知
    {
      path: '/workviews/proj_offerprice_notice/:trace_id/:state',
      name: 'proj_offerprice_notice',
      component: () => import(/* webpackChunkName: "proj_offerprice_notice" */ '@/views/work_views/Proj_OfferPrice_Notice.vue'),
      meta: {
        index: 314,
        title: '项目报价通知'
      }
    },
    //经纬专家派单通知
    {
      path: '/workviews/Proj_Task_JW_Pai_Notice/:trace_id/:state',
      name: 'Proj_Task_JW_Pai_Notice',
      component: () => import(/* webpackChunkName: "Proj_Task_JW_Pai_Notice" */ '@/views/work_views/Proj_Task_JW_Pai_Notice.vue'),
      meta: {
        index: 315,
        title: '经纬专家派单通知'
      }
    },
    //备案项目通知
    {
      path: '/workviews/Proj_Registration_Notice/:trace_id/:state',
      name: 'Proj_Registration_Notice',
      component: () => import(/* webpackChunkName: "Proj_Registration_Notice" */ '@/views/work_views/Proj_Registration_Notice.vue'),
      meta: {
        index: 316,
        title: '项目备案通知'
      }
    },
    //新增备案项目通知
    {
      path: '/workviews/Proj_Registration_Add/',
      name: 'Proj_Registration_Add',
      component: () => import(/* webpackChunkName: "Proj_Registration_Add" */ '@/views/work_views/Proj_Registration_Add.vue'),
      meta: {
        index: 317,
        title: '新增项目备案'
      }
    },
    //备案项目查看
    {
      path: '/workviews/Proj_Registration_View/:trace_id',
      name: 'Proj_Registration_View',
      component: () => import(/* webpackChunkName: "Proj_Registration_View" */ '@/views/work_views/Proj_Registration_View.vue'),
      meta: {
        index: 318,
        title: '查看项目备案'
      }
    },
    {  //待办里的立项提交,和 “立项提交列表”里的‘立项提交’共用一个提交页面。
       //path里的Proj_Submit_Add 部分，对应的是worklist表中form_name值的页面部分。
      path: '/workviews/Proj_Submit_Add/:trace_id/:state',
      name: 'Proj_Submit_Add',
      component: () => import(/* webpackChunkName: "Proj_Submit_Add" */ '@/views/Biz/Apply_Proj_Submit.vue'),
      meta: {
        index: 319,
        title: '立项提交'
      }
    },
    {  //待办里的立项提交,和 “立项提交列表”里的‘立项提交’共用一个提交页面。
      path: '/workviews/Proj_Submit_Add_HZ/:trace_id/:state',
      name: 'Proj_Submit_Add_HZ',
      component: () => import(/* webpackChunkName: "Proj_Submit_Add" */ '@/views/Biz/Apply_Proj_Submit.vue'),
      meta: {
        index: 320,
        title: '立项提交'
      }
    }
  ]
});
export default router